angular.module('workflow')
    .controller('WorkflowEditController', function ($scope, $state, $rootScope, toastr, Workflow, item, WorkflowService, Principal) {
        this.WorkflowService = WorkflowService
        this.tabOpened = 0

        this.$onInit = () => {
            this.item = item
            this.canEditConfidential = Principal.hasAnyAuthority(['ROLE_WORKFLOW_CONFIDENTIAL'])
            this.shortForm = this.item && this.item.shortForm === true
            this.directions = WorkflowService.getDirections()
            if (this.item && !this.item.responseTo && this.item.responseToWorkflow) {
                this.item.responseTo = this.item.responseToWorkflow
            }
            if (this.item && this.item.responseTo && this.item.responseTo.id) {
                this.item.responseToOther = true
            } else if (this.shortForm) {
                this.item.responseToOther = false
            } else if (this.item.responseToOther !== true && this.item.responseToOther !== false) {
                this.item.responseToOther = null
            }
        }

        this.onDateOfDeadlineChanged = () => {
            if (this.item.dateOfDeadline == null) {
                delete this.item.strictDeadline
            }
        }

        this.save = () => {
            const payload = angular.copy(this.item)
            if (!payload.responseTo && payload.responseToWorkflow) {
                payload.responseTo = payload.responseToWorkflow
            }
            if (payload.responseToOther !== true) {
                payload.responseTo = null
            }
            let promise
            if (payload.id != null) {
                promise = Workflow.update(payload).$promise
            } else {
                promise = Workflow.save(payload).$promise
            }
            return promise.then(response => {
                if (response && response.id != null) {
                    angular.extend(this.item, response)
                }
                $rootScope.$broadcast('workflow.updated')
                toastr.success("Zapisano")
                if (this.item.id != null)
                    $state.go('workflowShowFull', {id: this.item.id})
                else
                    $state.go('workflowList')
            })
        }

        this.onResponseTypeChanged = () => {
            if (this.item.responseToOther !== true) {
                this.item.responseTo = null
            }
        }

        this.selectResponseToWorkflow = () => {
            const alreadySelectedIds = this.item && this.item.id ? [this.item.id] : []
            const oppositeDirection = this.item && this.item.direction === 'IN'
                ? 'OUT'
                : (this.item && this.item.direction === 'OUT' ? 'IN' : null)

            const selectFilters = {
                alreadySelectedIds: alreadySelectedIds
            }

            if (oppositeDirection != null) {
                selectFilters.direction = oppositeDirection
            }

            return this.WorkflowService.select(selectFilters).then(selected => {
                this.item.responseTo = selected
                this.item.responseToOther = true
            })
        }

        this.clearResponseToWorkflow = () => {
            this.item.responseTo = null
        }

        $scope.$on("file.saved", () => $state.reload())
    })
